/**
 * Helpers for opening YouTube / Vimeo / HTML5 video in FsLightbox with autoplay.
 * Providers show their own loading UI; FsLightbox shows its spinner until sources are ready.
 */

export function createAutoplayYouTubeIframe(code) {
    const iframe = document.createElement('iframe');
    iframe.classList.add('fslightbox-youtube-iframe');
    iframe.src = 'https://www.youtube.com/embed/' + code + '?autoplay=1&rel=0';
    iframe.width = '1920px';
    iframe.height = '1080px';
    iframe.setAttribute('allow', 'autoplay; fullscreen; encrypted-media');
    iframe.allowFullscreen = true;
    iframe.frameBorder = '0';

    return iframe;
}

export function createAutoplayVimeoIframe(code) {
    const iframe = document.createElement('iframe');
    iframe.classList.add('fslightbox-vimeo-iframe');
    iframe.src = 'https://player.vimeo.com/video/' + code + '?autoplay=1';
    iframe.width = '1920px';
    iframe.height = '1080px';
    iframe.setAttribute('allow', 'autoplay; fullscreen');
    iframe.allowFullscreen = true;
    iframe.frameBorder = '0';

    return iframe;
}

/**
 * Start an HTML5 <video> created by FsLightbox from an MP4 URL (unmuted).
 * Call from props.onOpen after a user gesture (play / consent click).
 * Callers should set props.types = ['video'] so the node exists synchronously;
 * we still wait briefly if detection was async.
 */
export function playHtmlVideoInLightbox(popup) {
    const container = popup && popup.elements && popup.elements.container;
    if (!container) {
        return;
    }

    const start = (video) => {
        video.muted = false;

        const tryPlay = () => {
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => {
                    // Autoplay with sound blocked; native controls remain available.
                });
            }
        };

        if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
            tryPlay();
            return;
        }

        video.addEventListener('canplay', tryPlay, { once: true });
        tryPlay();
    };

    const existing = container.querySelector('video');
    if (existing) {
        start(existing);
        return;
    }

    const observer = new MutationObserver(() => {
        const video = container.querySelector('video');
        if (!video) {
            return;
        }

        observer.disconnect();
        start(video);
    });

    observer.observe(container, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 5000);
}
